import React, { useMemo } from "react";
import { Link } from "react-router-dom";

import { Table } from "react-bootstrap";
import { IUmpireUser } from "../../../../../../types/api";

const BonusTable = ({
    umpires,
}: {
    umpires: IUmpireUser[];
}): React.JSX.Element => {
    return (
        <Table striped>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Games</th>
                </tr>
            </thead>
            <tbody>
                {umpires.map(u => (
                    <tr key={u.id}>
                        <td style={{ width: "50%" }}>
                            <Link to={`/admin/umpires/${u.id}`} target="_blank">
                                {u.name}
                            </Link>
                        </td>
                        <td style={{ width: "25%" }}>{u.games}</td>
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default BonusTable;
